<script setup>
import WrOurPromiseSection from "~/components/global/WrOurPromiseSection.vue";

const route = useRoute();
const slug = route.params.slug;
const config = useRuntimeConfig();
const baseURL = config.public.baseUrl;
const { data, error } = await useFetch(
  `${baseURL}/content/services/development-services/${slug}-content.json`
);

if (error.value || !data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page not found",
  });
}

useHead({
  title: data?.value?.meta_tags?.title || "",
  meta: data?.value?.meta_tags?.meta || [],
  link: [{ rel: "preload", as: "image", href: data?.value?.header.image }],
});

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};

const text = `Ready to hire us? <span class=" underline cursor-pointer" @click="openModal" Click here</span> and let’s get cracking!`;
</script>

<template>
  <section class="max-w-screen-xl px-4 mx-auto">
    <div
      class="flex max-md:flex-col justify-between gap-10 max-w-screen-xl mx-auto px-4 lg:px-8"
    >
      <WrServicesHeroSection
        :heading="data?.header.heading"
        :description="data?.header.text"
        :src="data?.header.image"
        :alt="data?.header.heading"
        width="497"
        height="429"
        @open-modal="openModal"
      />
    </div>
  </section>

  <section class="max-w-screen-xl px-4 mt-10 relative z-10 mx-auto">
    <div class="max-w-screen-xl mx-auto py-10 px-4 lg:px-8">
      <FloatingList
        :heading="data?.google_autocomplete?.heading"
        :subheading="data?.google_autocomplete?.subheading"
        :expertisetext="data?.expertise?.expertisetext"
        :textcontent="data?.expertise?.textcontent"
        :text="data?.google_autocomplete?.text"
        :keywords="data?.google_autocomplete?.keywords"
      />
      <GoogleRating />
    </div>
  </section>

  <section class="max-w-screen-lg px-4 xl:mt-20 mt-16 relative z-10 mx-auto">
    <div class="max-w-screen-xl mx-auto">
      <WrExpertiseSection :expertise="data?.expertise" />
    </div>
  </section>

  <section class="max-w-screen-xl px-4 mt-16 relative z-10 mx-auto">
    <div class="max-w-screen-xl mx-auto py-20">
      <WrWhoAreWeCard
        :heading="data?.service_content?.heading"
        :subheading="data?.service_content?.subheading"
        :content="data?.service_content?.text"
      />
    </div>
  </section>

  <section class="max-w-screen-xl xl:px-4 px-10 mt-20 relative z-10 mx-auto">
    <WrImageContent
      @openModal="openModal"
      :whyChooseUs="data?.why_choose_us"
      src="/images/why-chose-us.webp"
      height="360"
      width="466"
       header="Let’s start together"
    />
  </section>

  <section class="max-w-screen-xl px-4 mt-20 relative z-10 mx-auto">
    <WrOurPromiseSection :data="data?.our_promises" />
  </section>

  <section
    class="relative z-10 max-w-screen-xl py-10 lg:pb-28 overflow-visible grid place-items-center order-9"
  >
    <div class="max-w-screen-lg mx-auto px-4 w-full relative">
      <div
        class="hidden dark:block opacity-30 size-[764px] rounded-full bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] absolute -top-[30%] -left-[67%]"
      ></div>
      <div
        class="hidden dark:block opacity-50 size-[190px] rounded-full bg-[image:var(--bg-circle-top-light)] absolute -bottom-[15%] -right-80"
      ></div>
    </div>
  </section>
  <section class="section-spacing">
    <div class="container-wrapper-lg">
      <WrSelectedProject />
    </div>
  </section>
  <WrOurServiceSection
    title="Our Capabilities"
    description="One of our latest add-on skills from the newest technologies."
  />

  <section
    class="relative pt-10 lg:pt-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20"
  >
    <h4 class="text-center mb-11">
      <WrGradientText
        text="Trusted for excellence and efficiency"
        append-class="text-3xl lg:text-[48px]"
      />
      <p class="text-lg text-[var(--foreground)] font-anvtgrade-book">
        Webreinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </p>
    </h4>
    <!-- Carousel Section -->
    <WrTestimonialCardCarousel />
    <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
      >View All</WrButton
    >
  </section>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
